import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
} from '@angular/core';
import { ToastController, Platform, ModalController } from '@ionic/angular';

import { StripeService } from '../../services/stripe.service';
import { UserService } from '../../services/user.service';
import { Utilities } from '../../utilities/utilities';
import { ClientService } from '../../services/client.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { ENV_CONFIG } from '../../../bin/env.config';

declare var Stripe: stripe.StripeStatic;

@Component({
  selector: 'app-card-on-file',
  templateUrl: './card-on-file.component.html',
  styleUrls: ['./card-on-file.component.scss'],
})
export class CardOnFileComponent implements OnInit {
  @ViewChild('cardElement') cardElement: ElementRef;
  public stripe;

  public cardOnFile: boolean = false;

  public card;

  public paymentInfo;
  public paymentMethodID: string;

  public cardInfo = {
    brand: '',
    last4: '',
    exp_month: '',
    exp_year: '',
    funding: '',
    paymentMethodID: '',
  };

  public paymentMethodType;

  @Input() client;

  public cardErrors;

  public confirmation;

  public currency;

  public chargePushed: boolean = false;

  public chargeAndSavePushed: boolean = false;

  public errorMessage;

  public paymentIntent;

  public chargeSavedCardPushed: boolean = false;

  // public paymentField : FormControl;

  // public paymentForm: FormGroup;

  public amountInput: number;

  public loadStripeComponent = false;
  @Input() clientHasStripeID = false;
  public refreshStripe = 0;
  public style = {
    base: {
      color: '#32325D',
      fontWeight: 500,
      fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
      fontSize: '16px',
      fontSmoothing: 'antialiased',

      '::placeholder': {
        color: '#CFD7DF',
      },
      ':-webkit-autofill': {
        color: '#e39f48',
      },
    },
    invalid: {
      color: '#E25950',

      '::placeholder': {
        color: '#FFCCA5',
      },
    },
  };

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private inAppBrowser: InAppBrowser,
    private stripeService: StripeService,
    private ref: ChangeDetectorRef,
    public userService: UserService,
    private clientService: ClientService,
    private toastCtrl: ToastController //  private formBuilder: FormBuilder
  ) {}

  public ngOnInit() {
    this.currency = Utilities.decodeHtml(
      this.userService.getSalon().getCurrency()
    );
    // this.clientHasStripeID = this.navParams.get('clientHasStripeID');
    this.stripeService
      .getClientStripeID({ clientID: this.client.id })
      .subscribe((clientStripeIDResponse) => {
        this.clientHasStripeID = !!clientStripeIDResponse;

        if (this.clientHasStripeID) {
          this.stripeService
            .getCustomerCardInfo({ clientID: this.client.id })
            .subscribe((cardInfo) => {
              this.cardInfo = cardInfo;
              if (this.cardInfo) {
                if (this.cardInfo.brand) {
                  this.paymentMethodID = this.cardInfo.paymentMethodID;
                  this.cardOnFile = true;
                  this.ref.detectChanges();
                }
              }
            });
        }
      });
  }

  public ngAfterViewInit() {
    this.stripe = Stripe(ENV_CONFIG.stripePublicKey);

    const elements = this.stripe.elements();

    this.card = elements.create('card', { style: this.style });
    this.card.mount(this.cardElement.nativeElement);
    this.card.addEventListener('change', ({ error }) => {
      this.cardErrors = error && error.message;
    });
  }

  public onDismiss() {
    this.modalCtrl.dismiss();
  }

  public saveCardOnFile() {
    this.errorMessage = false;

    if (this.cardOnFile) {
      this.stripeService
        .detachPaymentMethod({ paymentMethodID: this.cardInfo.paymentMethodID })
        .toPromise()
        .then((result) => {})
        .catch((error) => {});
    }

    this.stripeService
      .clientIntentSecret({
        clientID: this.client.id,
        newClient: !this.clientHasStripeID,
        clientName:
          this.client.getFirstName() + ' ' + this.client.getLastName(),
      })
      .subscribe({
        next: (clientSecret) => {
          this.stripe
            .confirmCardSetup(clientSecret, {
              payment_method: {
                card: this.card,
                billing_details: {
                  name:
                    this.client.getFirstName() +
                    ' ' +
                    this.client.getLastName(),
                },
              },
            })
            .then(async (setupIntent) => {
              if (setupIntent.setupIntent) {
                // sometimes the setup intent is nested
                setupIntent = setupIntent.setupIntent;
              }
              if (setupIntent.status === 'succeeded') {
                this.modalCtrl.dismiss(true);
                const toast = await this.toastCtrl.create({
                  message: 'Card was successfully saved on file',
                  duration: 4000,
                });
                toast.present();
              } else {
                this.cardErrors = setupIntent.error.message;
                this.ref.detectChanges();
              }
            })
            .catch((error) => {
              this.cardErrors = `${error.message}`;
              this.ref.detectChanges();
            });
        },
        error: (error) => {
          this.cardErrors = `${error.message}`;
          this.ref.detectChanges();
        },
      });
  }

  public onCardAuthorizationLink() {
    const cardAuthorizationLink: string = `https://salonmonster.com/resources/card_on_file_authorization_form.pdf`;
    if (this.platform.is('capacitor')) {
      this.inAppBrowser.create(cardAuthorizationLink, '_system');
    } else {
      window.open(cardAuthorizationLink, '_blank');
    }
  }

  public async requestCardFromClient() {
    // insert request into the database
    // email client

    this.clientService
      .sendClientCardRequest(this.client, this.userService.getSalon().getId())
      .subscribe(
        async (response) => {
          console.log(response);
          const toast = await this.toastCtrl.create({
            message: 'Credit card request has been sent to client',
            duration: 4000,
          });
          toast.present();
          this.onDismiss();
        },
        async (error) => {
          const toast = await this.toastCtrl.create({
            message:
              'Oops! There was an error sending the request to the client',
            duration: 4000,
          });
          this.onDismiss();
        }
      );
  }
}
